import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { IconButton } from "@faire/web--source/slate/IconButton";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as React from "react";
import styled, { css } from "styled-components";
import { AvatarRenderer } from "@faire/retailer/components/LayoutElementRenderer/__internal__/AvatarRenderer";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { useLayoutElementCarouselCtaLink } from "@faire/retailer/components/LayoutElementRenderer/__internal__/useLayoutElementCarouselCtaLink";
import { TitleStyles } from "@faire/retailer/components/LayoutElementRenderer/styles/TitleStyles";
import { FaireMarketIcon } from "@faire/retailer/features/FaireMarkets/FaireMarketIcon";
import { showMarketTreatment, MY_MARKET_LIST_CAROUSEL } from "@faire/retailer/views/home/logged-in-homepage/Utils";
import { varArrowColor } from "../styles/styles.css";
export var LayoutElementCarouselTitleProps;
(function(LayoutElementCarouselTitleProps) {
    LayoutElementCarouselTitleProps.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(LayoutElementCarouselTitleProps || (LayoutElementCarouselTitleProps = {}));
var AuxiliaryTitle = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, onCTAClick = _React_useContext.onCTAClick, requestId = _React_useContext.requestId;
    var showArrowCTA = props.showArrowCTA, showPrimaryBtn = props.showPrimaryBtn;
    var cta_link_to_search_products = layoutElement.cta_link_to_search_products, cta_link_to_search_makers = layoutElement.cta_link_to_search_makers, cta_link = layoutElement.cta_link, cta_text = layoutElement.cta_text, on_click_event_name = layoutElement.on_click_event_name;
    var ctaLink = useLayoutElementCarouselCtaLink(layoutElement, requestId);
    var showAuxiliaryTitleInternal = !!cta_link || !!cta_link_to_search_products || !!cta_link_to_search_makers;
    if (!showAuxiliaryTitleInternal) {
        return null;
    }
    var auxiliaryTitle = cta_text ? cta_text : strictLocalize({
        id: "kWg8zV",
        defaultMessage: [
            {
                type: 0,
                value: "See All"
            }
        ]
    });
    var desktopAuxiliaryTitle = /*#__PURE__*/ _jsx(_Fragment, {
        children: auxiliaryTitle
    });
    if (showPrimaryBtn) {
        return /*#__PURE__*/ _jsx(StyledButton, {
            linkTo: ctaLink,
            onClick: function() {
                return onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick(on_click_event_name !== null && on_click_event_name !== void 0 ? on_click_event_name : "", requestId);
            },
            children: cta_text
        });
    }
    var shouldShowMarketTreatment = showMarketTreatment(on_click_event_name);
    var _layoutElement_main_text_color;
    return /*#__PURE__*/ _jsx(TitleStyles.AuxiliaryTitle, {
        forwardedAs: "span",
        children: ctaLink ? /*#__PURE__*/ _jsxs(Button, {
            linkTo: ctaLink,
            variant: "tertiary",
            tertiaryColor: shouldShowMarketTreatment ? eventsThemeColors.faireMarket.promoText : undefined,
            onClick: function() {
                onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick(on_click_event_name !== null && on_click_event_name !== void 0 ? on_click_event_name : "", requestId);
            },
            children: [
                /*#__PURE__*/ _jsx(TitleStyles.AuxiliaryTitleArrow, {
                    $isVisible: !!showArrowCTA,
                    children: /*#__PURE__*/ _jsx(StyledIconButton, {
                        variant: "tertiary",
                        "aria-label": auxiliaryTitle,
                        style: assignInlineVars(_define_property({}, varArrowColor, (_layoutElement_main_text_color = layoutElement.main_text_color) !== null && _layoutElement_main_text_color !== void 0 ? _layoutElement_main_text_color : "inherit")),
                        children: /*#__PURE__*/ _jsx(Arrow, {
                            "data-test-id": "arrow-cta",
                            direction: "right",
                            fontSize: "16px"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(TitleStyles.AuxiliaryTitleText, {
                    $isVisible: !showArrowCTA,
                    children: desktopAuxiliaryTitle
                })
            ]
        }) : cta_text
    });
};
var CarouselDescription = function(param) {
    var descriptionText = param.descriptionText, descriptionCtaText = param.descriptionCtaText, descriptionCtaLink = param.descriptionCtaLink, descriptionTextColor = param.descriptionTextColor, leftAlign = param.leftAlign;
    if (!descriptionText) {
        return null;
    }
    var getDescriptionLink = function() {
        if (descriptionCtaText && descriptionCtaLink) {
            return /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: descriptionCtaLink,
                target: "_blank",
                tertiaryColor: descriptionTextColor,
                style: {
                    paddingLeft: getSpacing("1x")
                },
                children: descriptionCtaText
            });
        }
        return null;
    };
    return /*#__PURE__*/ _jsxs(TitleStyles.Subtitle, {
        $leftAlignTitle: leftAlign,
        children: [
            descriptionText,
            getDescriptionLink()
        ]
    });
};
export var Title = function(param) {
    var className = param.className, leftAlignTitle = param.leftAlignTitle, showArrowCTA = param.showArrowCTA, showPrimaryBtn = param.showPrimaryBtn, titleClassName = param.titleClassName;
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onCTAClick = _React_useContext.onCTAClick;
    var main_text = layoutElement.main_text, tagline_text = layoutElement.tagline_text, description_text = layoutElement.description_text, cta_text = layoutElement.cta_text, on_click_event_name = layoutElement.on_click_event_name, display_page = layoutElement.display_page, main_text_color = layoutElement.main_text_color, cta_text_color = layoutElement.cta_text_color, tagline_text_color = layoutElement.tagline_text_color;
    var link = useLayoutElementCarouselCtaLink(layoutElement, requestId);
    if ([
        main_text,
        tagline_text,
        description_text,
        cta_text
    ].some(isNotUndefined)) {
        var shouldShowMarketTreatment = showMarketTreatment(on_click_event_name);
        var noMarketBackground = on_click_event_name === MY_MARKET_LIST_CAROUSEL;
        var mainTextColor = shouldShowMarketTreatment && !noMarketBackground ? eventsThemeColors.faireMarket.promoText : main_text_color;
        var ctaTextColor = shouldShowMarketTreatment && !noMarketBackground ? eventsThemeColors.faireMarket.promoText : cta_text_color;
        var mainTitle = /*#__PURE__*/ _jsxs(TitleStyles.MainTitleRow, {
            gap: "1x",
            "data-show-arrow-cta": showArrowCTA,
            children: [
                shouldShowMarketTreatment ? /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                    tabletAndAbove: /*#__PURE__*/ _jsx(FaireMarketIcon, {
                        size: "32px"
                    }),
                    mobile: /*#__PURE__*/ _jsx(MobileFaireMarketIcon, {
                        size: "24px"
                    })
                }) : null,
                /*#__PURE__*/ _jsx(TitleStyles.MainTitle, {
                    $leftAlignTitle: leftAlignTitle,
                    maxLines: display_page === ILayoutElement.DisplayPage.FAIRE_MARKET_HOMEPAGE_V2 ? 3 : 2,
                    color: mainTextColor,
                    children: layoutElement.main_text
                })
            ]
        });
        return /*#__PURE__*/ _jsxs(TitleStyles.Container, {
            className: className,
            $showMarketTreatment: shouldShowMarketTreatment && !noMarketBackground,
            children: [
                /*#__PURE__*/ _jsxs(TitleStyles.HeaderTaglineWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(AvatarRenderer, {
                            layoutElement: layoutElement
                        }),
                        /*#__PURE__*/ _jsx(TitleStyles.Header, {
                            $leftAlignTitle: leftAlignTitle,
                            color: tagline_text_color,
                            children: tagline_text
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(TitleContentWrapper, {
                    className: titleClassName,
                    $mobileAlignInColumn: showPrimaryBtn,
                    children: [
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: {
                                mobileAndAbove: 0,
                                tabletAndAbove: 8
                            },
                            children: [
                                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                                    tabletAndAbove: mainTitle,
                                    mobile: cta_text && link ? /*#__PURE__*/ _jsx(Link, {
                                        to: link,
                                        color: ctaTextColor,
                                        onClick: function() {
                                            var _layoutElement_on_click_event_name;
                                            onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId);
                                        },
                                        children: mainTitle
                                    }) : mainTitle
                                }),
                                /*#__PURE__*/ _jsx(CarouselDescription, {
                                    descriptionText: layoutElement.description_text,
                                    descriptionCtaText: layoutElement.description_cta_text,
                                    descriptionCtaLink: layoutElement.description_cta_link,
                                    descriptionTextColor: layoutElement.description_text_color,
                                    leftAlign: leftAlignTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(AuxiliaryTitle, {
                            showArrowCTA: showArrowCTA,
                            showPrimaryBtn: showPrimaryBtn
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
var StyledIconButton = styled(IconButton).withConfig({
    componentId: "sc-8303a941-0"
})([
    "& > div{color:",
    " !important;}"
], varArrowColor);
var MobileFaireMarketIcon = styled(FaireMarketIcon).withConfig({
    componentId: "sc-8303a941-1"
})([
    "margin-top:4px;"
]);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-8303a941-2"
})([
    "width:261px;",
    "{width:318px;}"
], responsiveMediaQueries.tabletAndAbove);
var TitleContentWrapper = styled(Flex).attrs({
    gap: "1x",
    justify: "space-between"
}).withConfig({
    componentId: "sc-8303a941-3"
})([
    "",
    "{flex-wrap:wrap;}",
    "{",
    "}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.mobile, function(props) {
    return props.$mobileAlignInColumn ? css([
        "flex-direction:column;"
    ]) : "";
});
